import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// File: App.tsx
import { useEffect, useState, Suspense, lazy } from "react";
import { Routes, Route } from "react-router-dom";
import { useDispatch } from "react-redux";
import { auth } from "./firebase";
import { SET_USER_UID } from "./Redux/actions";
import modulesRoutes from "./routes/modulesRoutes";
import LoadingComponent from "./components/LoadingComponent";
const ProtectedLayout = lazy(() => import("./components/ProtectedLayout"));
import { InvariantErrorBoundary } from "./components/InvariantErrorBoundary";
const LearningDashboard = lazy(() => import("./components/LearningDashboard"));
const TrackDisplay = lazy(() => import("./components/TrackDisplay"));
const Login = lazy(() => import("./components/Login"));
const ForgotPassword = lazy(() => import("./components/ForgotPassword"));
const Register = lazy(() => import("./components/Register"));
const ResetPassword = lazy(() => import("./components/ResetPassword"));
const NotFound = lazy(() => import("./pages/NotFound"));
const App = () => {
    const dispatch = useDispatch();
    const [loggedUser, setLoggedUser] = useState(null);
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        console.log("App: setting up Firebase auth listener");
        const unsubscribe = auth.onAuthStateChanged((user) => {
            const timestamp = new Date().toISOString();
            console.log(`[${timestamp}] Firebase auth state changed`);
            console.log(`[${timestamp}] Full user object:`, user);
            if (user) {
                // Only update Redux if the user exists
                console.log(`[${timestamp}] Firebase auth user detected:`, user.uid);
                setLoggedUser(user.displayName ?? user.email ?? "User");
                dispatch({ type: SET_USER_UID, payload: user.uid });
                console.log(`[${timestamp}] Dispatched SET_USER_UID with payload:`, user.uid);
                // ✅ Additional debug log
                console.log("[DEBUG] Redux UID after dispatch:", user ? user.uid : null);
                localStorage.setItem("authCode", user.uid);
                localStorage.setItem("name", user.displayName ?? user.email ?? "User");
                localStorage.setItem("userId", user.uid);
            }
            else {
                console.log(`[${timestamp}] Firebase auth no user detected`);
                setLoggedUser(null);
                // Prevent overwriting Redux UID with null
                console.log(`[${timestamp}] Skipping Redux UID overwrite with null`);
                localStorage.removeItem("authCode");
                localStorage.removeItem("name");
                localStorage.removeItem("userId");
            }
            console.log(`[${timestamp}] App: setting loading to false`);
            setLoading(false);
        });
        return () => {
            console.log("App: cleaning up Firebase auth listener");
            unsubscribe();
        };
    }, [dispatch]);
    if (loading) {
        console.log("App: rendering loading screen");
        return _jsx("div", { children: "Loading..." });
    }
    return (_jsxs(Suspense, { fallback: _jsx(LoadingComponent, {}), children: [loggedUser && (_jsxs("div", { style: {
                    color: "transparent",
                    background: "#f8f9fa",
                    padding: "8px 16px",
                    fontWeight: "bold",
                    textAlign: "center",
                }, children: ["Logged in as: ", loggedUser] })), _jsxs(Routes, { children: [_jsx(Route, { path: "/login", element: _jsx(Login, { setloggeduser: setLoggedUser }) }), _jsx(Route, { path: "/register", element: _jsx(Register, {}) }), _jsx(Route, { path: "/forgot-password", element: _jsx(ForgotPassword, {}) }), _jsx(Route, { path: "/reset-password", element: _jsx(ResetPassword, {}) }), _jsxs(Route, { element: _jsx(ProtectedLayout, {}), children: [_jsx(Route, { path: "/", element: _jsx(InvariantErrorBoundary, { children: _jsx(LearningDashboard, {}) }) }), _jsx(Route, { path: "/tracks/:trackId", element: _jsx(TrackDisplay, {}) }), modulesRoutes.map(({ path, element }) => (_jsx(Route, { path: path, element: element }, path))), _jsx(Route, { path: "*", element: _jsx(NotFound, {}) })] }), _jsx(Route, { path: "*", element: _jsx(NotFound, {}) })] })] }));
};
export default App;
